export default __webpack_public_path__ + "static/spain-bg-cd6b07b0a752e5e1b48b831e78c4db2a.png";